import React, { useState } from "react";

//Styles
import "./Cover.scss";

//Components
import Button from "common-components/Button/Button";
import { ReactComponent as YouTubeIcon } from "assets/youtube.svg";
import VideoModal from "./VideoModal/VideoModal";

function Cover() {
  const [isModalShown, setIsModalShown] = useState(false);
  return (
    <section className="page-landing cover">
      <h1>Custom logo design</h1>
      <h2>Get unique logo designs by running a contest</h2>
      <Button styleType="primary rounded">Get Started</Button>
      <p>from $275</p>
      <button
        className="video-modal-trigger like-link"
        onClick={() => {
          setIsModalShown(true);
        }}
      >
        <YouTubeIcon />
        See how it works
      </button>
      <VideoModal isModalShown={isModalShown} setIsModalShown={setIsModalShown} />
    </section>
  );
}

export default Cover;
